import { useEffect } from 'react';
import authProvider from '../authProvider';

const AuthWrapper = ({ children }) => {
  useEffect(() => {
    authProvider().authenticate();
  }, []);
  return (children);
};

export default AuthWrapper;
